<script lang="ts" setup>

</script>

<template>
  <MButton preset="black_1">
    <MText size="2lg" class=" font-black">
      <slot></slot>
    </MText>
    <span class=" text-[18px] font-bold">
      <SvgoArrowup></SvgoArrowup>
    </span>
  </MButton>
</template>

<style lang="scss" scoped></style>
